export { default } from './DefaultLocationsTable';
